import axios from 'axios';
import qs from 'qs';
import { BACKEND_URL } from '../../env';
import { getCookie } from '../helper/helper';

export const handleAPI = (path, method, params, data = null, responseType = 'json', options = {}) => {
  const headers = {
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    ...(getCookie('token') && { Authorization: getCookie('token') }),
    ...(options.headers || {}),
  };

  let url = BACKEND_URL + path;
  if (params) {
    url = url + '?' + qs.stringify(params, { arrayFormat: 'brackets' });
  }

  const axiosConfig = {
    method,
    url,
    ...(data && { data }),
    responseType,
    headers,
    withCredentials: true,
    ...options,
  };

  return axios(axiosConfig);
};
